import { EventPageVisibility } from '@graphql/generated';

/**
 * Reusable utility function for checking if a page is visible
 * A page is considered visible if it's public or password protected
 */
export const isEventPageVisible = (visibility?: EventPageVisibility) => {
  if (!visibility) return false;
  return [EventPageVisibility.public, EventPageVisibility.passwordProtected].includes(visibility);
};
